import { Component, OnInit } from '@angular/core';
import { AnnouncementBarService } from './announcement-bar.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-announcement-bar',
  templateUrl: './announcement-bar.component.html',
  styleUrls: ['./announcement-bar.component.scss']
})
export class AnnouncementBarComponent implements OnInit {
  showAnnouncement = false;
  private routerSubscription: Subscription;

  constructor(
    public announcementService: AnnouncementBarService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.showAnnouncement = this.announcementService.shouldShowAnnouncement();

    // Subscribe to router events to reset announcement when navigating
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Reset announcement visibility when navigating to a new page
      this.showAnnouncement = this.announcementService.shouldShowAnnouncement();
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  onClose(): void {
    this.showAnnouncement = false;
  }

  onActionClick(): void {
    const config = this.announcementService.getConfig();
    if (config.actionUrl) {
      window.open(config.actionUrl, '_blank');
    }
  }
}
